import {initializeApp} from "firebase/app";
import {getMessaging, getToken} from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDgD4ZOBTePTmUkNg_Lw_lh8UwpQQ63YxA",
    authDomain: "bmgo-flutter-app.firebaseapp.com",
    projectId: "bmgo-flutter-app",
    storageBucket: "bmgo-flutter-app.firebasestorage.app",
    messagingSenderId: "540682400754",
    appId: "1:540682400754:web:f59af8f5f2ce183feb316b",
    measurementId: "G-DJX62R9QPJ"
};
// 🔥 tutaj następuje inicjalizacja Firebase:
const app = initializeApp(firebaseConfig);

// Następnie możesz pobrać konkretne usługi
const messaging = getMessaging(app);

export {app, messaging, getToken};